import React from 'react';
import { CheckIcon } from 'lucide-react';
interface FeaturePointProps {
  children: React.ReactNode;
}
const FeaturePoint22 = ({
  children
}: FeaturePointProps) => {
  return <div className="flex items-start" data-id="element-1228">
      <div className="flex-shrink-0 mt-1" data-id="element-1229">
        <CheckIcon className="h-4 w-4 text-gray-700" data-id="element-1230" />
      </div>
      <div className="ml-2 text-sm text-gray-700" data-id="element-1231">{children}</div>
    </div>;
};
export default FeaturePoint22;